<template>
    <el-popover placement="bottom"
                width="450"
                trigger="click"
                v-model="show">
        <el-tabs v-model="activeName"
                 type="card">
            <el-tab-pane label="省份"
                         name="1">
                <ul v-loading="loading"
                    class="selectList">
                    <li v-for="(item, index) in proList"
                        @click="handleClick(item)"
                        :key="index"
                        :class="{active: isEmpty(item.code, 1)}"
                        :title="item.name">{{item.name}}
                    </li>
                </ul>
            </el-tab-pane>
            <el-tab-pane label="城市"
                         name="2">
                <ul v-loading="loading"
                    class="selectList">
                    <li v-for="(item, index) in cityList"
                        @click="handleClick(item)"
                        :key="index"
                        :class="{active: isEmpty(item.code, 2)}"
                        :title="item.name">{{item.name}}
                    </li>
                </ul>
            </el-tab-pane>
            <!-- <el-tab-pane label="区县"
                         name="3"
                         v-if="isShow(3)">
                <ul v-loading="loading"
                    class="selectList">
                    <li v-for="(item, index) in distList"
                        @click="handleClick(item)"
                        :key="index"
                        :class="{active: isEmpty(item.code, 3)}"
                        :title="item.name">{{item.name}}
                    </li>
                </ul>
            </el-tab-pane> -->
        </el-tabs>
        <el-input v-model="query"
                  slot="reference"
                  v-bind="$attrs"
                  readonly></el-input>
    </el-popover>
</template>

<script>
import { querycaption } from "@/api/homePage";
export default {
    name: "ym-select",
    // props: {
    //     value: {
    //         type: [String, Array]
    //     },
    //     max: {
    //         type: String,
    //         default: "3"
    //     },
    //     join: {
    //         type: String,
    //         default: "-"
    //     },
    //     simple: Boolean
    // },
    data() {
        return {
            proList: [],
            show: false, // 下拉框显示与隐藏
            query: "", // input
            activeName: "1", // tabs 选项卡
            loading: false, // 加载状态
            cityList: [], // 城市列表
            distList: [], // 区县列表
            selectList: [] // 加载状态
        };
    },
    // computed: {
    //     proList() {
    //         return this.$store.state.proList;
    //     }
    // },
    watch: {
        value: {
            handler: function(val) {
                if (Object.prototype.toString.call(val) === "[object Array]") {
                    this.query = val.map(item => item.name).join(this.join);
                } else {
                    this.query = val;
                }
            },
            immediate: true
        }
    },
    created() {
        this.queryProvince();
    },
    methods: {
        queryProvince() {
            querycaption({ parentCode: "100000" }).then(res => {
                if (res.status === 2000) {
                    this.proList = res.data;
                    console.log(this.proList);
                }
            });
        },
        // async firstLoad() {
        //     // 第一次加载 判断省份是否已经请求过了
        //     if (!this.proList.length) {
        //         this.loading = true;
        //     }
        // },
        handleClick(item) {
            // 判断max name大于当前tabs name
            let activeNum = parseInt(this.activeName);
            if (parseInt(this.max) > activeNum) {
                let listName = "cityList";
                switch (this.activeName) {
                    case "1": // 省份
                        this.activeName = "2";
                        listName = "cityList";
                        this.distList = []; // 清空区县列表
                        this.selectList = [item]; // 清空选择列表 并且push新选择列表
                        break;
                    case "2": // 城市
                        this.activeName = "3";
                        listName = "distList";
                        this.selectList.splice(1, 1, item);
                        break;
                    default:
                        break;
                }
                this.loading = true;
                queryprovinceandcity({ parentCode: item.code })
                    .then(res => {
                        this[listName] = res;
                    })
                    .finally(() => {
                        this.loading = false;
                    });
            } else {
                // 赋值input
                this.setVal(item, activeNum - 1);
            }
        },
        setVal(item, num) {
            // 赋值
            this.selectList.splice(num, 1, item);
            if (this.simple) {
                const simpleSelect = this.selectList
                    .map(item => item.name)
                    .join(this.join);
                // this.$emit("input", simpleSelect);
            } else {
                // this.$emit("input", this.selectList);
            }
            // this.$emit("onChange", this.selectList);
            this.show = false;
        },
        isEmpty(code, num) {
            // 判断是否选中;
            if (this.selectList.length >= num) {
                return code === this.selectList[num - 1].code;
            } else {
                return false;
            }
        },
        isShow(num) {
            return parseInt(this.max) >= num;
        }
    }
};
</script>

<style lang="scss" scoped>
.selectList {
    margin: 0;
    padding: 0;
    min-height: 100px;
    > li {
        width: 25%;
        padding: 10px 0;
        display: inline-block;
        text-align: center;
        font-size: 13px;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
        &:hover {
            background-color: #eee;
            cursor: pointer;
        }
    }
    .active {
        background-color: #eee;
    }
}
</style>
